"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Link = _interopRequireDefault(require("@instructure/ui-elements/lib/components/Link"));
var _TruncateText = _interopRequireDefault(require("@instructure/ui-elements/lib/components/TruncateText"));
var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");
var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));
var _dec, _class, _class2, _temp;
var BreadcrumbLink = (
/**
---
parent: Breadcrumb
---
**/
_dec = (0, _uiTestable.default)(), _dec(_class = (_temp = _class2 = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(BreadcrumbLink, _Component);
  function BreadcrumbLink() {
    (0, _classCallCheck2.default)(this, BreadcrumbLink);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BreadcrumbLink).apply(this, arguments));
  }
  (0, _createClass2.default)(BreadcrumbLink, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        href = _this$props.href,
        icon = _this$props.icon,
        iconPlacement = _this$props.iconPlacement,
        onClick = _this$props.onClick;
      var props = (0, _passthroughProps.omitProps)(this.props, BreadcrumbLink.propTypes); // Link will display a button by default, even if there is no action.
      // Force a span in this case.

      var as = href || onClick ? void 0 : 'span';
      return _react.default.createElement(_Link.default, Object.assign({
        as: as
      }, props, {
        href: href,
        icon: icon,
        iconPlacement: iconPlacement,
        onClick: onClick
      }), _react.default.createElement(_TruncateText.default, null, children));
    }
  }]);
  BreadcrumbLink.displayName = "BreadcrumbLink";
  return BreadcrumbLink;
}(_react.Component), _class2.propTypes = {
  /**
  * Content to render as the crumb, generally should be text.
  */
  children: _propTypes.default.node.isRequired,
  /**
  * Link the crumb should direct to; if an href is provided, the crumb will render as a link
  */
  href: _propTypes.default.string,
  /**
  * If the BreadcrumbLink has an onClick prop (and no href), it will render as a button
  */
  onClick: _propTypes.default.func,
  /**
  * Sets the font-size of the breadcrumb text
  */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  /**
  * Add an icon to the BreadcrumbLink
  */
  icon: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),
  /**
  * Place the icon before or after the text in the BreadcrumbLink
  */
  iconPlacement: _propTypes.default.oneOf(['start', 'end'])
}, _class2.defaultProps = {
  href: void 0,
  onClick: void 0,
  size: void 0,
  icon: void 0,
  iconPlacement: void 0
}, _temp)) || _class);
exports.default = BreadcrumbLink;